import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjayAvatar } from '../../DjayAvatar';
export function ShadowRealmIllustration({
  achievementId,
  variant = 'shadow',
  // Unlocks shadow variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3678">
      <div className="relative w-full h-full bg-slate-950 overflow-hidden" data-id="element-3679">
        {/* Background: Dark Aura */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3680">
          <circle cx="100" cy="100" r="80" fill="#4C1D95" opacity="0.3" filter="blur(20px)" data-id="element-3681" />
          <circle cx="100" cy="100" r="50" fill="#000000" opacity="0.5" filter="blur(10px)" data-id="element-3682" />

          {/* Shadow tendrils */}
          <path d="M100 100 Q40 40 20 80" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-3683" />
          <path d="M100 100 Q160 160 180 120" stroke="#5B21B6" strokeWidth="8" strokeLinecap="round" opacity="0.4" filter="blur(2px)" data-id="element-3684" />
          <path d="M100 100 Q150 40 120 20" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-3685" />
          <path d="M100 100 Q50 160 80 180" stroke="#4C1D95" strokeWidth="6" strokeLinecap="round" opacity="0.5" filter="blur(2px)" data-id="element-3686" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3687">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3688">
            <DjayAvatar size="hero" emotion={isUnlocked ? 'surprised' : 'thinking'} variant={variant} accessory="shadowOrb" animate={animate && isUnlocked} className="w-full h-full" data-id="element-3689" />
          </div>
        </div>

        {/* Foreground: Glowing Eyes / Dark Particles */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3690">
            {/* Particles */}
            <circle cx="40" cy="60" r="3" fill="#A78BFA" opacity="0.8" data-id="element-3691" />
            <circle cx="160" cy="80" r="2" fill="#8B5CF6" opacity="0.6" data-id="element-3692" />
            <circle cx="140" cy="150" r="4" fill="#C4B5FD" opacity="0.5" data-id="element-3693" />
            <circle cx="60" cy="140" r="2.5" fill="#7C3AED" opacity="0.7" data-id="element-3694" />

            {/* Vignette border */}
            <rect x="0" y="0" width="200" height="200" fill="url(#vignette)" data-id="element-3695" />
            <defs data-id="element-3696">
              <radialGradient id="vignette" cx="50%" cy="50%" r="50%" fx="50%" fy="50%" data-id="element-3697">
                <stop offset="70%" stopColor="black" stopOpacity="0" data-id="element-3698" />
                <stop offset="100%" stopColor="black" stopOpacity="0.6" data-id="element-3699" />
              </radialGradient>
            </defs>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}